import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Crown, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const goto = (id) => {
    setOpen(false);
    if (window.location.pathname !== "/") {
      nav("/#" + id);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const links = [
    { id: "services", label: "Services", testId: "nav-link-services" },
    { id: "ai-chat", label: "AI Chat", testId: "nav-link-ai-chat" },
    { id: "booking", label: "Book 1-on-1", testId: "nav-link-booking" },
    { id: "pricing", label: "Membership", testId: "nav-link-pricing" },
    { id: "tips", label: "Tips Vault", testId: "nav-link-tips" },
    { id: "merch", label: "Perks", testId: "nav-link-merch" },
  ];

  return (
    <nav
      data-testid="main-nav-bar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[rgba(10,10,14,0.72)] border-b border-[var(--border-subtle)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="w-8 h-8 grid place-items-center rounded-md bg-gradient-to-br from-[var(--gold)] to-[#8a6b12] text-[#0a0a0e] font-black">
            <Crown size={16} strokeWidth={2.5} />
          </span>
          <div className="leading-none">
            <div className="font-display text-xl tracking-widest">
              GET RIGHT
            </div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-[var(--text-muted)]">
              by Dev Da Don
            </div>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => goto(l.id)}
              className="px-3 py-2 text-sm text-[var(--text-secondary)] hover:text-[var(--gold)] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          {user && typeof user === "object" ? (
            <>
              <Link
                to="/dashboard"
                data-testid="nav-link-dashboard"
                className="text-sm text-[var(--text-secondary)] hover:text-[var(--gold)]"
              >
                Dashboard
              </Link>
              <button
                onClick={logout}
                data-testid="nav-logout-btn"
                className="gr-btn-ghost px-4 py-2 rounded-full text-sm"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login-btn"
                className="text-sm text-[var(--text-secondary)] hover:text-[var(--gold)]"
              >
                Sign in
              </Link>
              <button
                onClick={() => goto("booking")}
                data-testid="nav-cta-book-button"
                className="gr-btn-gold px-5 py-2 rounded-full text-sm"
              >
                Book Consultation
              </button>
            </>
          )}
        </div>

        <button
          className="lg:hidden text-[var(--text-primary)]"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[var(--border-subtle)] px-4 py-4 space-y-2 bg-[var(--bg-primary)]">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => goto(l.id)}
              className="w-full text-left px-2 py-2 text-sm text-[var(--text-secondary)]"
            >
              {l.label}
            </button>
          ))}
          {user && typeof user === "object" ? (
            <>
              <Link
                to="/dashboard"
                onClick={() => setOpen(false)}
                className="block px-2 py-2 text-sm"
              >
                Dashboard
              </Link>
              <button
                onClick={() => {
                  logout();
                  setOpen(false);
                }}
                className="w-full text-left px-2 py-2 text-sm"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                onClick={() => setOpen(false)}
                className="block px-2 py-2 text-sm"
              >
                Sign in
              </Link>
              <Link
                to="/register"
                onClick={() => setOpen(false)}
                className="block px-2 py-2 text-sm text-[var(--gold)]"
              >
                Get started
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
